import { render } from "./BorrowRequestManagement.vue?vue&type=template&id=66624bfb&scoped=true"
import script from "./BorrowRequestManagement.vue?vue&type=script&lang=js"
export * from "./BorrowRequestManagement.vue?vue&type=script&lang=js"

import "./BorrowRequestManagement.vue?vue&type=style&index=0&id=66624bfb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66624bfb"]])

export default __exports__